import { FC } from "react";

import { SectionScoreCard } from "../SectionScoreCard";

import { SectionScoreDashboard } from "./SectionScoreDashboard";

import { SECTION_SETTINGS_GRADE_TAB_INDEX } from "components/modals/SectionSettingsModal";
import { t } from "i18n/i18n";
import { EmptyCard } from "mds/components/EmptyCard";
import { IconText } from "mds/components/IconText";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { AssessPointsMarkerIcon, GearSettingsIcon } from "mds/icons";
import { useAppDispatch } from "store/index";
import { selectCurrentSection } from "store/selectors";
import { viewStateActions } from "store/slices/view";
import { useObjectSelector } from "store/store-hooks";

export const SectionScorePanel: FC = () => {
  const dispatch = useAppDispatch();
  const section = useObjectSelector(selectCurrentSection, ["section_score_enabled"]);
  const isMdOrLarger = useIsMdOrLarger();

  const openSectionScoreSettings = () => {
    dispatch(viewStateActions.setSectionSettingsTabIndex(SECTION_SETTINGS_GRADE_TAB_INDEX));
  };

  if (!section) {
    return null;
  }

  return (
    <>
      {section.section_score_enabled ? (
        <SectionScoreCard />
      ) : (
        <EmptyCard
          action={
            <SquareButton
              className="shrink-0"
              kind="tertiary"
              size="s"
              onClick={openSectionScoreSettings}
            >
              <IconText
                iconStart={<GearSettingsIcon />}
                text={
                  isMdOrLarger
                    ? t("assessment_dashboard.grades.settings")
                    : t("assessment_dashboard.grades.settings_short")
                }
              />
            </SquareButton>
          }
          className="text-base"
          icon={<AssessPointsMarkerIcon className="text-blue" />}
          title={t("assessment_dashboard.section_scores_disabled")}
        />
      )}
      <SectionScoreDashboard />
    </>
  );
};
